import { render, staticRenderFns } from "./FormRelatedArticle.vue?vue&type=template&id=03ee81ae&"
import script from "./FormRelatedArticle.vue?vue&type=script&lang=js&"
export * from "./FormRelatedArticle.vue?vue&type=script&lang=js&"
import style0 from "./FormRelatedArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports